var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdditionalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.97231 0 0 8.97231 0 20C0 31.0277 8.97231 40 20 40C31.0277 40 40 31.0277 40 20C40 8.97231 31.0277 0 20 0ZM20 3.07692C29.3646 3.07692 36.9231 10.6354 36.9231 20C36.9231 29.3646 29.3646 36.9231 20 36.9231C10.6354 36.9231 3.07692 29.3646 3.07692 20C3.07692 10.6354 10.6354 3.07692 20 3.07692ZM18.4615 10.7692V18.4615H10.7692V21.5385H18.4615V29.2308H21.5385V21.5385H29.2308V18.4615H21.5385V10.7692H18.4615Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalIcon);
export default __webpack_public_path__ + "static/media/additional_icon.54754fd15c4eec31c2852ea9206e02e3.svg";
export { ForwardRef as ReactComponent };